var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCardCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 11,
  fill: "none",
  viewBox: "0 0 16 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#176F69",
  d: "M4.574 5.265a.55.55 0 0 1 .777.016l1.083 1.127 3.113-3.005a.55.55 0 0 1 .764.791L6.8 7.582a.55.55 0 0 1-.778-.015L4.558 6.043a.55.55 0 0 1 .016-.778"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#176F69",
  fillRule: "evenodd",
  d: "M2.83.5a.67.67 0 0 0-.655.537L.457 9.704a.667.667 0 0 0 .654.796h10.658a.67.67 0 0 0 .654-.537l.158-.796h2.453a.667.667 0 0 0 .653-.802l-1.512-7.28a.7.7 0 0 0-.116-.26.67.67 0 0 0-.572-.325zm.355 1.1L1.638 9.4h9.775l1.546-7.8zM13.63 3.872 12.8 8.067H14.5z",
  clipRule: "evenodd"
})));
export { SvgCardCheck as ReactComponent };